import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import { translate } from '../../../strings/i18n';
import { DisclaimerText } from './subcomponents';
const Disclaimer = () => {
    return (_jsxs(_Fragment, { children: [_jsx(DisclaimerText, { children: translate('disclaimer.disclaimer') }), _jsx(Stack, { size: "xxlarge", hideOnBreakpointUp: "small" })] }));
};
export default Disclaimer;
